module.exports = __webpack_public_path__ + "static/media/location_pointer_icon.5ba90ec4.svg";